module.exports = __webpack_public_path__ + "static/media/sony-75class-tv.9f82c4b3.jpg";